import React from "react";

import { PAGE_TITLES } from "src/app/constants";
import JsonFormsClaimIntakeApp from "src/jsonForms/JsonFormsClaimIntakeApp";

import ClaimIntakeAppLayoutPage from "./ClaimIntakeAppLayoutPage";

/**
 * Generic page wrapper for the JSON-forms pre-screening flow.
 *
 * Mounts at `/json-forms` and `/json-forms/<lob>/claim-intake-form` for
 * `<lob>` in `{wc, cargo, ipl}`. The wrapper itself is LOB-agnostic —
 * branching on LOB and on the schema-fetch lifecycle lives entirely
 * inside `JsonFormsClaimIntakeApp` (the JsonFormsClaimIntakeApp). Renders the
 * shared `ClaimIntakeAppLayoutPage` chrome so all four routes share the
 * same shell.
 */
function JsonFormsClaimIntakePage(): JSX.Element {
  return (
    <ClaimIntakeAppLayoutPage
      pageTitle={PAGE_TITLES.CLAIM_INTAKE_FORM}
      content={<JsonFormsClaimIntakeApp />}
    />
  );
}

export default JsonFormsClaimIntakePage;
